import React, { Component } from "react";
import styles from "./Item.local.scss";
import classnames from "classnames";

export default class OrganizationListFetching extends Component {
  render() {
    let items = [];
    for (let i = 0; i < 3; i++) {
      items.push(
        <div key={i} className={`row border-draft ${styles.list_item}`}>
          <div className="medium-1" />
          <div
            className={`medium-4 ${styles.list_item__header}`}
            style={{ marginLeft: "-6.1%", marginRight: "2%" }}
          >
            <div className={styles.list_item__first_header}>
              <h3 className={styles.gradiant} style={{ width: "200px" }}>
                {""}
              </h3>
              <h4 className={styles.gradiant} />
            </div>

            <div className={styles.list__row_groups_cell_wrapper}>
              <div className={styles.groups_block_position}>
                <span className={styles.gradiant} />
                <span className={styles.gradiant} />
              </div>
            </div>
          </div>

          <div
            className={`medium-1 ${styles.list_item__key}`}
            style={{ marginLeft: "20px" }}
          >
            <h4 className={styles.gradiant} />
            <h4 className={styles.gradiant} />
            <h4 className={styles.gradiant} />
          </div>
          <div className={`medium-1 ${styles.list_item__key}`}>
            <h4 className={styles.gradiant} />
            <h4 className={styles.gradiant} />
            <h4 className={styles.gradiant} />
          </div>
          <div className={`medium-1 ${styles.list_item__key}`}>
            <h4 className={styles.gradiant} />
            <h4 className={styles.gradiant} />
            <h4 className={styles.gradiant} />
          </div>

          <div className={`medium-4 ${styles.presentation_fetching}`}>
            <div className={styles.presentation_img_fetching} />
            <div className={styles.presentation_items_info_fetching}>
              <span className={styles.gradiant} />
              <span className={styles.gradiant} />
              <span className={styles.gradiant} />
            </div>

            <span
              className={classnames(
                styles.list_item__status_fetching,
                styles.gradiant
              )}
            />
          </div>
        </div>
      );
    }
    return (
      <div className={`small-12 columns ${styles.item__fetching}`}>{items}</div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/OrganizationList/OrganizationListFetching.js